<template>
    <div class="project">
        <advertising-figure :bannerSrc="bannerSrc"/>
        <div class="inner-page-nav">
            <inner-page-nav />
        </div>
        <div class="inner-page-content">
            <public-title :title="title">
                <span class="sub">Arrangement of the meeting</span>
            </public-title>

            <div class="divider">
                <h2 class="tit">联系我们</h2>
                <span class="time">发布日期: {{ simpleDateFormat(affair.create_time) }}</span>
            </div>

            <div class="meet-detail-wrap">
                <!-- <h2 class="tit">{{currentConference.title}}</h2> -->
                <div class="meet-detail">
      
                    <!-- <p class="meet-item">
                        <span class="small-tit">联系我们:</span>
                        {{content}}
                    </p> -->
                    <div class="inputDeep">
                        <el-input type="textarea" readonly :rows="6" v-model="affair.link"></el-input>
                    </div>
           
                </div>
            </div>
            <!-- <v-textarea
            v-model="content"
            label="联系我们："
            outlined
            ></v-textarea> -->
        </div>
    </div>
</template>

<script>
import AdvertisingFigure from "@components/advertising";
import InnerPageNav from "@components/tool-nav";
import publicTitle from "@components/title";
import CurrentConferMixin from "@/mixin/CurrentConference"
export default {
    name: "MeetDetailPage",
    components: {
        AdvertisingFigure,
        InnerPageNav,
        publicTitle,
    },
    mixins: [CurrentConferMixin],
    data() {
        return {
            bannerSrc:require("@assets/img/meeting-banner.png"),
            title: "会务安排",
            content:"",
            affair:{}
        };
    },
    created(){
        if(this.currentConference.affairs!=undefined && this.currentConference.affairs.length>0){
            this.affair =  this.currentConference.affairs[0]
        }
    },
    watch: {
      currentConference: {
        handler(val) {
          if (val) {
            if (val.affairs.length > 0) {
              this.affair = val.affairs[0]
            }
          }
          console.log(val)
        },
        deep: true,
      },
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/innerpagenav.scss";
/* 如果你的 el-input type 设置成textarea  */
::v-deep .inputDeep .el-textarea__inner {
    border: 0;
    resize: none;/* 这个是去掉 textarea 下面拉伸的那个标志 */
  }

.inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
}

.inner-page-content {
    margin: 60px 0;
}

.divider {
    @include flex-between;
    width: 1200px;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    margin: 30px auto 60px;
    border-bottom: 1px solid #eee;

    .tit {
        position: relative;
        font-size: 18px;
        color: #666;

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 30px;
            height: 2px;
            background: $defaultColor;
        }
    }

    .time {
        font-size: 14px;
        color: #999;
    }
}

.meet-detail-wrap {
    width: 1200px;
    margin: 0 auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);

    .meet-detail {
        width: 100%;
        padding: 30px;
    }

    .tit {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        display: inline-block;
        min-width: 180px;
        font-size: 20px;
        margin: 30px 0;
        color: $defaultColor;
        padding: 0 30px;
        text-align: center;

        &:before {
            content: "";
            position: absolute;
            top: 50%;
            left: -100px;
            width: 100px;
            height: 2px;
            background: linear-gradient(to right, transparent, #ccc);
        }

        &:after {
            content: "";
            position: absolute;
            top: 50%;
            right: -100px;
            width: 100px;
            height: 2px;
            background: linear-gradient(to left, transparent, #ccc);
        }
    }

    .meet-item {
        font-size: 14px;
        color: #666;
        margin-bottom: 15px;
        line-height: 30px;

        .small-tit {
            color: $defaultColor;
        }
    }
}
</style>